module.exports = __webpack_public_path__ + "static/img/14.99e2d43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene/14.jpg
// module id = FYeQ
// module chunks = 3